
export class ThinningMeasurement {

    id: string;
    created: string;
    data: any;
    data_analysis: any;
    summary: any;

    constructor(private fields: any) {
        // Quick and dirty extend/assign fields to this model
        for (let f in fields) {
            this[f] = fields[f];
        }
    }

}



// WEBPACK FOOTER //
// ./src/models/thinning-measurement.ts